import { Theme } from '@mui/material';

// ----------------------------------------------------------------------

export default function CssBaseline(theme: Theme) {
    const arrowColor = theme.palette.grey[400].replace('#', '%23');

    const upArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E%3Cpath d='M3 0 L6 6 L0 6 Z' fill='${arrowColor}'/%3E%3C/svg%3E")`;
    const downArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E%3Cpath d='M3 6 L6 0 L0 0 Z' fill='${arrowColor}'/%3E%3C/svg%3E")`;
    const leftArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E%3Cpath d='M0 3 L6 6 L6 0 Z' fill='${arrowColor}'/%3E%3C/svg%3E")`;
    const rightArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E%3Cpath d='M6 3 L0 6 L0 0 Z' fill='${arrowColor}'/%3E%3C/svg%3E")`;

    return {
        MuiCssBaseline: {
            styleOverrides: {
                '*::-webkit-scrollbar': {
                    width: '6px',
                },
                '*::-webkit-scrollbar:horizontal': {
                    height: '6px',
                },
                '*::-webkit-scrollbar-track': {
                    background: theme.palette.background.paper,
                },
                '*::-webkit-scrollbar-thumb': {
                    background: theme.palette.grey[400],
                    borderRadius: '3px',
                },
                '*::-webkit-scrollbar-button': {
                    display: 'block',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    height: '6px',
                    width: '6px',
                    backgroundSize: '6px',
                },
                '*::-webkit-scrollbar-button:vertical:start:decrement': {
                    backgroundImage: upArrow,
                },
                '*::-webkit-scrollbar-button:vertical:end:increment': {
                    backgroundImage: downArrow,
                },
                '*::-webkit-scrollbar-button:horizontal:start:decrement': {
                    backgroundImage: leftArrow,
                },
                '*::-webkit-scrollbar-button:horizontal:end:increment': {
                    backgroundImage: rightArrow,
                },
            },
        },
    };
}
